export const DefaultShiftGroup = {
  shiftGroup: "DefaultShiftGroup",
  shiftStart: "08:00",
  workplaceName: "Default Workplace Name",
  workplaceAddress: "Default Address",
  minimumShiftDuty: 1,
  restDays: ["Saturday", "Sunday"]
}
